import { render, staticRenderFns } from "./IncidentStatusChip.vue?vue&type=template&id=541e8412&scoped=true&"
import script from "./IncidentStatusChip.vue?vue&type=script&lang=js&"
export * from "./IncidentStatusChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541e8412",
  null
  
)

export default component.exports